[
  { "code": "AF", "nationality": "Afghano" },
  { "code": "AL", "nationality": "Albanese" },
  { "code": "DZ", "nationality": "Algerino" },
  { "code": "AS", "nationality": "Samoano Americano" },
  { "code": "AD", "nationality": "Andorrano" },
  { "code": "AO", "nationality": "Angolano" },
  { "code": "AI", "nationality": "Anguillano" },
  { "code": "AG", "nationality": "Antiguano o Barbudano" },
  { "code": "AR", "nationality": "Argentino" },
  { "code": "AM", "nationality": "Armeno" },
  { "code": "AU", "nationality": "Australiano" },
  { "code": "AT", "nationality": "Austriaco" },
  { "code": "AZ", "nationality": "Azerbaigiano" },
  { "code": "BS", "nationality": "Bahamense" },
  { "code": "BH", "nationality": "Bahreinita" },
  { "code": "BD", "nationality": "Bangladese" },
  { "code": "BB", "nationality": "Barbadiano" },
  { "code": "BY", "nationality": "Bielorusso" },
  { "code": "BE", "nationality": "Belga" },
  { "code": "BZ", "nationality": "Beliziano" },
  { "code": "BJ", "nationality": "Beninese" },
  { "code": "BM", "nationality": "Bermudiano" },
  { "code": "BT", "nationality": "Bhutanese" },
  { "code": "BO", "nationality": "Boliviano" },
  { "code": "BA", "nationality": "Bosniaco o Erzegovino" },
  { "code": "BW", "nationality": "Botswano" },
  { "code": "BR", "nationality": "Brasiliano" },
  { "code": "BN", "nationality": "Bruneiano" },
  { "code": "BG", "nationality": "Bulgaro" },
  { "code": "BF", "nationality": "Burkinabé" },
  { "code": "BI", "nationality": "Burundese" },
  { "code": "KH", "nationality": "Cambogiano" },
  { "code": "CM", "nationality": "Camerunese" },
  { "code": "CA", "nationality": "Canadese" },
  { "code": "CV", "nationality": "Capoverdiano" },
  { "code": "CF", "nationality": "Centrafricano" },
  { "code": "TD", "nationality": "Ciadiano" },
  { "code": "CL", "nationality": "Cileno" },
  { "code": "CN", "nationality": "Cinese" },
  { "code": "CO", "nationality": "Colombiano" },
  { "code": "KM", "nationality": "Comoriano" },
  { "code": "CG", "nationality": "Congolese" },
  { "code": "CR", "nationality": "Costaricano" },
  { "code": "HR", "nationality": "Croato" },
  { "code": "CU", "nationality": "Cubano" },
  { "code": "CY", "nationality": "Cipriota" },
  { "code": "CZ", "nationality": "Ceco" },
  { "code": "DK", "nationality": "Danese" },
  { "code": "DJ", "nationality": "Gibutiano" },
  { "code": "DM", "nationality": "Dominicense" },
  { "code": "DO", "nationality": "Dominicano" },
  { "code": "EC", "nationality": "Ecuadoriano" },
  { "code": "EG", "nationality": "Egiziano" },
  { "code": "SV", "nationality": "Salvadoregno" },
  { "code": "GQ", "nationality": "Guineano Equatoriale" },
  { "code": "ER", "nationality": "Eritreo" },
  { "code": "EE", "nationality": "Estone" },
  { "code": "ET", "nationality": "Etiope" },
  { "code": "FJ", "nationality": "Figiano" },
  { "code": "FI", "nationality": "Finlandese" },
  { "code": "FR", "nationality": "Francese" },
  { "code": "GA", "nationality": "Gabonese" },
  { "code": "GM", "nationality": "Gambiano" },
  { "code": "GE", "nationality": "Georgiano" },
  { "code": "DE", "nationality": "Tedesco" },
  { "code": "GH", "nationality": "Ghanese" },
  { "code": "GR", "nationality": "Greco" },
  { "code": "GD", "nationality": "Grenadino" },
  { "code": "GT", "nationality": "Guatemalteco" },
  { "code": "GN", "nationality": "Guineano" },
  { "code": "GW", "nationality": "Guineano-Bissau" },
  { "code": "GY", "nationality": "Guyanese" },
  { "code": "HT", "nationality": "Haitiano" },
  { "code": "HN", "nationality": "Honduregno" },
  { "code": "HU", "nationality": "Ungherese" },
  { "code": "IS", "nationality": "Islandese" },
  { "code": "IN", "nationality": "Indiano" },
  { "code": "ID", "nationality": "Indonesiano" },
  { "code": "IR", "nationality": "Iraniano" },
  { "code": "IQ", "nationality": "Iracheno" },
  { "code": "IE", "nationality": "Irlandese" },
  { "code": "IL", "nationality": "Israeliano" },
  { "code": "IT", "nationality": "Italiano" },
  { "code": "JM", "nationality": "Giamaicano" },
  { "code": "JP", "nationality": "Giapponese" },
  { "code": "JO", "nationality": "Giordano" },
  { "code": "KZ", "nationality": "Kazako" },
  { "code": "KE", "nationality": "Keniano" },
  { "code": "KR", "nationality": "Sudcoreano" },
  { "code": "KW", "nationality": "Kuwaitiano" },
  { "code": "KG", "nationality": "Kirghiso" },
  { "code": "LA", "nationality": "Laotiano" },
  { "code": "LV", "nationality": "Lettone" },
  { "code": "LB", "nationality": "Libanese" },
  { "code": "LS", "nationality": "Lesothiano" },
  { "code": "LR", "nationality": "Liberiano" },
  { "code": "LY", "nationality": "Libico" },
  { "code": "LT", "nationality": "Lituano" },
  { "code": "LU", "nationality": "Lussemburghese" },
  { "code": "MG", "nationality": "Malgascio" },
  { "code": "MW", "nationality": "Malawiano" },
  { "code": "MY", "nationality": "Malese" },
  { "code": "MV", "nationality": "Maldivese" },
  { "code": "ML", "nationality": "Maliano" },
  { "code": "MT", "nationality": "Maltese" },
  { "code": "MR", "nationality": "Mauritano" },
  { "code": "MU", "nationality": "Mauriziano" },
  { "code": "MX", "nationality": "Messicano" },
  { "code": "MD", "nationality": "Moldavo" },
  { "code": "MC", "nationality": "Monegasco" },
  { "code": "MN", "nationality": "Mongolo" },
  { "code": "MA", "nationality": "Marocchino" },
  { "code": "MZ", "nationality": "Mozambicano" },
  { "code": "MM", "nationality": "Birmano" },
  { "code": "NA", "nationality": "Namibiano" },
  { "code": "NP", "nationality": "Nepalese" },
  { "code": "NL", "nationality": "Olandese" },
  { "code": "NZ", "nationality": "Neozelandese" },
  { "code": "NI", "nationality": "Nicaraguense" },
  { "code": "NE", "nationality": "Nigerino" },
  { "code": "NG", "nationality": "Nigeriano" },
  { "code": "NO", "nationality": "Norvegese" },
  { "code": "OM", "nationality": "Omanita" },
  { "code": "PK", "nationality": "Pakistano" },
  { "code": "PA", "nationality": "Panamense" },
  { "code": "PG", "nationality": "Papua Nuova Guinea" },
  { "code": "PY", "nationality": "Paraguayano" },
  { "code": "PE", "nationality": "Peruviano" },
  { "code": "PH", "nationality": "Filippino" },
  { "code": "PL", "nationality": "Polacco" },
  { "code": "PT", "nationality": "Portoghese" },
  { "code": "QA", "nationality": "Qatarino" },
  { "code": "RO", "nationality": "Rumeno" },
  { "code": "RU", "nationality": "Russo" },
  { "code": "RW", "nationality": "Ruandese" },
  { "code": "SA", "nationality": "Saudita" },
  { "code": "SN", "nationality": "Senegalese" },
  { "code": "RS", "nationality": "Serbo" },
  { "code": "SG", "nationality": "Singaporiano" },
  { "code": "SK", "nationality": "Slovacco" },
  { "code": "SI", "nationality": "Sloveno" },
  { "code": "SO", "nationality": "Somalo" },
  { "code": "ZA", "nationality": "Sudafricano" },
  { "code": "ES", "nationality": "Spagnolo" },
  { "code": "LK", "nationality": "Sri Lankese" },
  { "code": "SD", "nationality": "Sudanese" },
  { "code": "SE", "nationality": "Svedese" },
  { "code": "CH", "nationality": "Svizzero" },
  { "code": "SY", "nationality": "Siriano" },
  { "code": "TW", "nationality": "Taiwanese" },
  { "code": "TJ", "nationality": "Tagiko" },
  { "code": "TZ", "nationality": "Tanzaniano" },
  { "code": "TH", "nationality": "Tailandese" },
  { "code": "TG", "nationality": "Togolese" },
  { "code": "TT", "nationality": "Trinidadiano o Tobagano" },
  { "code": "TN", "nationality": "Tunisino" },
  { "code": "TR", "nationality": "Turco" },
  { "code": "TM", "nationality": "Turkmeno" },
  { "code": "UG", "nationality": "Ugandese" },
  { "code": "UA", "nationality": "Ucraino" },
  { "code": "AE", "nationality": "Emiratino" },
  { "code": "GB", "nationality": "Britannico" },
  { "code": "US", "nationality": "Americano" },
  { "code": "UY", "nationality": "Uruguayano" },
  { "code": "UZ", "nationality": "Uzbeko" },
  { "code": "VE", "nationality": "Venezuelano" },
  { "code": "VN", "nationality": "Vietnamita" },
  { "code": "YE", "nationality": "Yemenita" },
  { "code": "ZM", "nationality": "Zambiano" },
  { "code": "ZW", "nationality": "Zimbabwese" }
]

